import React from "react";
import { string, bool, func } from "prop-types";
import cx from "classnames";

const propTypes = {
  required: bool,
  error: bool,
  value: string.isRequired,
  label: string.isRequired,
  errorMsg: string,
  onChange: func,
  checked: bool,
};

const checkbox = props => {
  const { required, error, value, label, errorMsg, onChange, checked } = props;

  const handleChange = e => {
    if (onChange) {
      onChange(e.target.checked);
    }
  };

  return (
    <label
      className={cx("sc-form-item sc-form-item--checkbox", {
        "js-form-required": required,
        "sc-form-item--optional": !required,
        "has-error": error,
      })}
    >
      <input
        type="checkbox"
        aria-required={required}
        name={value}
        className="sc-form-item__field"
        onChange={handleChange}
        checked={checked}
      />
      <div className="sc-form-item__label">{label}</div>
      {errorMsg && (
        <span role="alert" className="sc-form-item__error-msg">
          {errorMsg}
        </span>
      )}
    </label>
  );
};

checkbox.propTypes = propTypes;
export default checkbox;
